import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  ConfiguracionAlcancesDispatcher,
  configuracionAlcancesDispatcher
} from "./ConfiguracionAlcances.dispatcher";
import {
  ConfiguracionAlcancesStore,
  configuracionAlcancesStore
} from "./ConfiguracionAlcances.store";
import ConfiguracionAlcancesComponent from "../../../components/comisionesAnualidadConfiguracion/configuracionAlcances";

interface Props
  extends ConfiguracionAlcancesStore,
    ConfiguracionAlcancesDispatcher {}

@ReduxConnect(configuracionAlcancesStore, configuracionAlcancesDispatcher)
export default class ConfiguracionAlcancesContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Configuración de Alcances de Comisión - Anualidades" />
          <ConfiguracionAlcancesComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
